import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { ToasterService } from 'angular2-toaster';
import * as _ from 'underscore';
export enum Pagination {
  limit = 20,
  skip = 0
}
@Component({
  selector: 'app-system-analytics',
  templateUrl: './system-analytics.component.html',
  styleUrls: ['./system-analytics.component.css']
})
export class SystemAnalyticsComponent implements OnInit {
  metadata: any = {};
  skip: number = Pagination.skip;
  limit: number = Pagination.limit;
  Keyword: string = " ";
  companydata: any = [];
  searchText: " ";
  infiniteScrollDistance = "1";
  isSort: boolean = true;
  isLoader: boolean = true;
  public pages: any = [];
	currentPage = 1;
  keyname:string = 'name';
  count: number;

  constructor(private apiService: ApiService, public toaster: ToasterService) {
    this.searchOneCompanyData = _.debounce(this.searchOneCompanyData, 1000);
  }
  ngOnInit(): void {
    this.getAllCompanyDetails();
    this.getOneCompanyData();
  }

  getAllCompanyDetails() {
    this.isLoader=true;
    this.apiService.getAllCompanyDetails().subscribe(response => {
      if (response['statusCode'] == 200 || response['statusCode'] == 201) {
      this.metadata = response['data'];
    }else{
      this.toaster.pop('error', response['message']);
    }}, error => {
      this.toaster.pop('error', error.error.message);
    })
  }

  getOneCompanyData() {
    this.isLoader = true;
    let payload: any = {
      skip: this.skip,
      limit: this.limit,
      keyName: this.keyname,
      sortBy: (this.isSort) ? 1 : -1
    }
    if ((this.searchText || []).length > 0) {
      payload.Keyword = this.searchText;
      delete payload.keyName;
      delete payload.sortBy;
    }
    
    this.apiService.getOneCompanyData(payload).subscribe((response:any) => {
      if (response['statusCode'] == 200 || response['statusCode'] == 201) {
        this.isLoader = false;
        this.companydata = [];
        this.companydata = response['data'];
        var length = Math.ceil(response.count[0].orgCount/this.limit);
          this.pages = [];
          for (let i = 1; i <= length; i++) {
            this.pages.push(i)
          }
      } else {
        this.toaster.pop('error', response['message']);
      }
    }, error => {
      this.toaster.pop('error', error.error.message);
    }
    );
  }

  searchOneCompanyData(event) {
    this.skip = Pagination.skip;
    this.limit = Pagination.limit;
    this.getOneCompanyData();
    // if(event.length > 0){
    //  this.skip = Pagination.skip
    //  this.limit = Pagination.limit;
    //  this.companydata = [];
    //  this.getOneCompanyData();
    // }
    // else{
    //    this.skip = Pagination.skip;
    //    this.limit = Pagination.limit;
    //    this.getOneCompanyData();
    // }
  }

  // onScroll() {
  //   this.skip += this.limit;
  //   // this.getOneCompanyData();
  // }

  onSort(event) {
    this.keyname = event;
    // this.isLoader = false;
    this.isSort = !this.isSort;
    this.skip = Pagination.skip;
    this.limit = Pagination.limit;
    this.currentPage = 1
    this.getOneCompanyData();
  }

  setPage(page) {
    // this.isLoader = false;
		this.currentPage = page;
    this.skip = (this.currentPage - 1) * this.limit;
    this.getOneCompanyData();
  }
}







// WEBPACK FOOTER //
// ./src/app/components/Systemanalytics/system-analytics.component.ts